import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  size?: number;
}

export function Logo({ className, size = 40 }: LogoProps) {
  const height = (size * 34) / 40;

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 40 34"
      fill="none"
      className={cn("", className)}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="url(#linqx-gradient)"
        d="m23.04 10.402-.004.014c1.984.842 3.678 2.709 4.53 5.113h.004l3.073-1.069c1-.349 1.445-2.072.955-3.682-.423-1.394-1.464-2.443-2.421-2.444-.132 0-.26.019-.375.061l-5.762 2.007Zm-2.375 4.705a1.12 1.12 0 0 0-.38.07l-3.028 1.06-.027.015c.57 1.365 1.72 2.277 2.651 1.952l3.06-1.064c-.481-1.181-1.416-2.032-2.276-2.033ZM8.568 22.604c.424 1.393 1.465 2.442 2.421 2.443.133 0 .26-.023.384-.066l5.775-2.01c-1.988-.839-3.686-2.7-4.538-5.105a.07.07 0 0 1-.009-.028l-3.077 1.078c-.56.198-.838.779-.952 1.11-.278.755-.277 1.69-.004 2.578Zm19.82-15.555a2.43 2.43 0 0 1 .789-.132c1.53.002 3.074 1.439 3.678 3.418.737 2.413-.073 4.868-1.801 5.476l-3.201 1.111c.102.496.22 1.478.203 2.409l3.681-1.282c2.884-1.003 4.324-4.788 3.217-8.444-.91-2.97-3.282-5.046-5.778-5.048-.507 0-1.005.084-1.473.244L16.942 8.554c-1.803.626-3.104 2.359-3.482 4.63a8.373 8.373 0 0 0 .195 3.569c.022.085.04.142.057.198l.013.057c.945 3.099 3.37 5.217 6.126 5.02l.07-.004 2.038-.711c.793-.273 1.256-1.472 1.159-2.742l-2.826.984a2.521 2.521 0 0 1-.794.131c-1.552-.001-3.065-1.405-3.674-3.417a2.425 2.425 0 0 1-.083-.326c-.579-2.32.245-4.575 1.885-5.145l10.762-3.75ZM5.274 18.667c-.564 1.567-.581 3.38-.056 5.104.904 2.972 3.277 5.051 5.773 5.053.507 0 1-.083 1.476-.248l7.354-2.563 3.408-1.186c1.513-.528 2.522-1.773 3.038-3.383.903-2.091.409-3.839.188-5.01l-.018-.061c-.9-2.967-3.278-5.042-5.774-5.044-.105 0-.215.004-.321.014h-.009l-2.297.805c-.794.273-1.247 1.434-1.137 2.719l2.976-1.04c.265-.09.53-.137.79-.137 1.556.002 3.069 1.405 3.682 3.418.031.108.058.203.08.307a4.614 4.614 0 0 1-.207 3.253c-.458 1.02-1.256 1.845-2.155 2.16 0 0-1.715.566-2.13.712l-1.049.344-7.102 2.444c-.256.089-.52.136-.794.136-1.552-.002-3.065-1.41-3.678-3.422-.366-1.19-.358-2.48.025-3.528.194-.557.692-1.562 1.772-1.944l3.122-1.078c-.004-.005-.004-.01-.004-.014a9.738 9.738 0 0 1-.19-2.399L8.43 15.332c-1.416.494-2.566 1.707-3.156 3.335Zm22.549 2.235c-.56 2.484-2.124 4.55-4.337 5.323l-3.113 1.088-7.494 2.609c-.609.212-8.836 2.909-5.565 1.905-3.271.794-6.401 2.984-6.96-.007-.623-2.03 3.015-11.79 3.685-13.664.736-2.025 2.186-3.55 3.98-4.175l4.22-1.47c.554-2.587 2.136-4.555 4.292-5.308l10.762-3.748c.6-.207 7.878-2.557 8.42-2.701.744-.199 4.026-1.3 4.005 1.49-.773 3.581-2.913 15.606-6.93 16.907l-4.965 1.751Z"
      />
      <defs>
        <linearGradient
          id="linqx-gradient"
          x1={19.964}
          x2={19.933}
          y1={0.395}
          y2={33.087}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5E3A3A" />
          <stop offset={1} stopColor="#C47979" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function LogoWithText({ className, size = 32 }: LogoProps) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Logo size={size} />
      <span className="text-xl font-bold tracking-tight">Linqx</span>
    </div>
  );
}
